import { getFormatPrice } from '../helpers'
import { criteriaMatchTypes, displayCriteriaFields, singleValueRangePrefixes } from './constants'

const findCriterion = (displayCriteria, field) => displayCriteria?.find(criterion => criterion.field === field)

const formatRange = (criterion, formatValue) => {
  const prefix = singleValueRangePrefixes[criterion?.match_type]

  if (prefix) return `${prefix} ${formatValue(criterion.match_value)}`
  if (criterion?.match_type === criteriaMatchTypes.valueInRange) {
    return `${formatValue(criterion.min_value)} - ${formatValue(criterion.max_value)}`
  }

  return null
}

export const getPriceRange = (displayCriteria, storeCurrency, language) => {
  const criterion = findCriterion(displayCriteria, displayCriteriaFields.orderNetValue)
  const currency = criterion?.match_currency || storeCurrency

  return formatRange(criterion, value => getFormatPrice(value, currency, language))
}

export const getWeightRange = displayCriteria => {
  const criterion = findCriterion(displayCriteria, displayCriteriaFields.shipmentWeight)
  const range = formatRange(criterion, value => value)

  if (!range) return null

  return `${range} g`
}
